import styled, { RuleSet, css } from 'styled-components';

const Topic = styled.div<{
  $desktopStyles?: RuleSet<object>;
  $mobileStyles?: RuleSet<object>;
}>(
  ({ theme, $desktopStyles, $mobileStyles }) => css`
    color: ${theme.co.primary20};
    font-family: ${theme.DEPRECATED_ty.openSans};
    font-size: ${theme.DEPRECATED_ty.medium};
    font-weight: ${theme.DEPRECATED_ty.bold};
    line-height: ${theme.DEPRECATED_ty.larger};
    ${$mobileStyles}

    @media (min-width: ${theme.sz.md}) {
      font-size: ${theme.DEPRECATED_ty.large};
      line-height: 130%;
      /* or 26px */
      ${$desktopStyles}
    }
  `,
);

export default Topic;
